import React from 'react';
import { Flex } from 'antd';
import type { FlexProps as AntFlexProps } from 'antd';
import type { BaseComponentProps } from '../../types/common';

export interface AndContainerProps extends AntFlexProps, BaseComponentProps {}

export const AndContainer: React.FC<AndContainerProps> = ({
  id, sessionId, develop, children, ...restProps
}) => {
  return <Flex {...restProps}>{children}</Flex>;
};

export default AndContainer;
